import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";




class ClaimListView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.uuid = this.app.guid();

		this.closing = false;
		
		this.state = {
			items: []
		}
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('ClaimListView.componentDidMount called');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();
		
		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));
		
		mvcmyquote.readClaims(rootsessionuuid, walletuuid)
		.then((claims) => {
			for (var i = 0; i < (claims ? claims.length : 0); i++) {
				claims[i].uuid = claims[i].txhash;

				claims[i].time = (claims[i].savetime ? claims[i].savetime/1000 : claims[i].blocktime);
				claims[i].formattedtime = mvcmodule.formatDate(claims[i].time, 'YYYY-mm-dd HH:MM:SS');

				switch(claims[i].status) {
					case 0: claims[i].statusstring = mvcmodule.t('unhandled'); break;
					case -1: claims[i].statusstring = mvcmodule.t('rejection pending'); break;
					case -10: claims[i].statusstring = mvcmodule.t('rejected'); break;
					case 1: claims[i].statusstring = mvcmodule.t('payment pending'); break;
					case 10: claims[i].statusstring = mvcmodule.t('paid'); break;
					default: claims[i].statusstring = mvcmodule.t('unknown'); break;
				}
			}

			// sort descending claim
			if (claims)
			claims.sort(function(a,b) {
				return ((b.time !== undefined ? b.time : 0) - (a.time !== undefined ? a.time : 0));
			});

			this._setState({items: claims});
		})
		.catch(err => {
			console.log('error in ClaimListView.componentDidMount: ' + err);
		});
	}
	
	async onRefreshPage() {
		console.log('ClaimListView.onRefreshPage called');
	}
	
	// end of life
	componentWillUnmount() {
		console.log('ClaimListView.componentWillUnmount called');

		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		this.closing = true;

		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}

	
	// user actions
	async onClickItem(item) {
		let txhash = item.txhash;
		let currencyuuid = item.currencyuuid;

		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let stop = false;
		let claim = await mvcmyquote.fetchClaim(rootsessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in ClaimListView.onClickItem ' + err);

			if (err == 'ERR_MISSING_CREDENTIALS') {
				this.app.alert('No sufficient rights to perform action.')
				stop = true;
			}
		});

		if (stop === true)
			return;

		if (!claim) {
			this.app.alert('Could not find claim. Claims may take a few seconds before being fully registered.')
			return;
		}

		let params = {action: 'view', txhash, currencyuuid, dataobject: claim};

		this.app.gotoRoute('claim', params);
	}

	renderItem(item){
		let mvcmodule = this.app.getMvcModuleObject();

		let title = mvcmodule.fitString(item.title, 21);
		let formattedtime = item.formattedtime;
		let answer = (item.private_submission === true ? 'private' : mvcmodule.fitString(item.answer, 21));
		let statusstring = item.statusstring;
		let uuid= item.txhash;

		return (
			<tr key={uuid} onClick={() => this.onClickItem(item)}>
				<th>{formattedtime}</th>
				<th>{title}</th>
				<th>{answer}</th>
				<th>{statusstring}</th>
			</tr>
		);

	}

	renderList() {
		let {items} = this.state;

		return (
			<Table responsive>
				<thead className="ListHeader">
					<tr>
					<th>Time</th>
					<th>Title</th>
					<th>Answer</th>
					<th>Status</th>
					</tr>
				</thead>
				<tbody className="ListItem" >
				{items.map((item, index) => {
					return (this.renderItem(item));
				})}
				</tbody>
			</Table>
		);

	}
	
	
	// rendering
	render() {
		let {items} = this.state;
		
		return (
			<div className="Container">
				<div className="Title">List of claims</div>
				{this.renderList()}
			</div>
		);
	}
	
}


// propTypes validation
ClaimListView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {ClaimListView};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimListView);

